import { render, staticRenderFns } from "./PauseDetail.vue?vue&type=template&id=4fe50240"
import script from "./PauseDetail.vue?vue&type=script&lang=js"
export * from "./PauseDetail.vue?vue&type=script&lang=js"
import style0 from "./PauseDetail.vue?vue&type=style&index=0&id=4fe50240&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports